import {
  GetCreateGameDocument,
  GetCreateGameQuery,
  GetCreateGameQueryVariables,
  GetMegaGameContractsDocument,
  GetMegaGameContractsQuery,
  GetMegaGameContractsQueryVariables,
  GetOrderRewardDocument,
  GetOrderRewardQuery,
  GetOrderRewardQueryVariables,
  GetPopularSpinDocument,
  GetPopularSpinQuery,
  GetPopularSpinQueryVariables,
  GetProjectJackpotsDocument,
  GetProjectJackpotsQuery,
  GetProjectJackpotsQueryVariables,
  GetProjectParticipantDocument,
  GetProjectParticipantQuery,
  GetProjectParticipantQueryVariables,
  GetProjectStatisticDocument,
  GetProjectStatisticQuery,
  GetSpinResultsDocument,
  GetSpinResultsQuery,
  GetSpinResultsQueryVariables,
  GetTotalParticipantsDocument,
  GetTotalParticipantsQuery,
  GetTotalParticipantsQueryVariables,
} from 'graphql/generated/graphql'
import apolloClient from './apollo-client'

const getMegaGameContracts = (variables: GetMegaGameContractsQueryVariables) => async () => {
  const response = await apolloClient().query<GetMegaGameContractsQuery>({
    query: GetMegaGameContractsDocument,
    variables,
  })
  return response.data.megaGameContracts
}
const getMegaGameContract = (variables: GetCreateGameQueryVariables) => async () => {
  const response = await apolloClient().query<GetCreateGameQuery>({
    query: GetCreateGameDocument,
    variables,
  })
  return response.data.createGame
}
const getMegaGameOrderReward = (variables: GetOrderRewardQueryVariables) => async () => {
  const response = await apolloClient().query<GetOrderRewardQuery>({
    query: GetOrderRewardDocument,
    variables,
  })
  return response.data.orderRewards
}
const getTotalParticipants = (variables: GetTotalParticipantsQueryVariables) => async () => {
  const response = await apolloClient().query<GetTotalParticipantsQuery>({
    query: GetTotalParticipantsDocument,
    variables,
  })
  return response.data.orders.reduce((prev, item) => prev + Number(item.qty), 0)
}

const getPopularSpin = (variables: GetPopularSpinQueryVariables) => async () => {
  const response = await apolloClient().query<GetPopularSpinQuery>({
    query: GetPopularSpinDocument,
    variables,
  })
  return response.data.createGames
}
const getProjectParticipant = (variables: GetProjectParticipantQueryVariables) => async () => {
  const response = await apolloClient().query<GetProjectParticipantQuery>({
    query: GetProjectParticipantDocument,
    variables,
  })
  return response.data.orders.reduce((prev, item) => prev + Number(item.qty), 0)
}
const getProjectStatistic = (variables: GetProjectParticipantQueryVariables) => async () => {
  const response = await apolloClient().query<GetProjectStatisticQuery>({
    query: GetProjectStatisticDocument,
    variables,
  })
  return response.data.orders
}
const getSpinResults = (variables: GetSpinResultsQueryVariables) => async () => {
  const response = await apolloClient().query<GetSpinResultsQuery>({
    query: GetSpinResultsDocument,
    variables,
  })
  return response.data.orderDetail
}
const getProjectJackpots = (variables: GetProjectJackpotsQueryVariables) => async () => {
  const response = await apolloClient().query<GetProjectJackpotsQuery>({
    query: GetProjectJackpotsDocument,
    variables,
  })
  return response.data.createGames
}
export default {
  getMegaGameContracts,
  getMegaGameContract,
  getMegaGameOrderReward,
  getTotalParticipants,
  getPopularSpin,
  getProjectParticipant,
  getProjectStatistic,
  getSpinResults,
  getProjectJackpots,
}
